import { v4 as uuidv4 } from 'uuid';

export const addNewContainer = async (name, token, limit) => {
    const guid = uuidv4();

    try {
        const res = await fetch(`${process.env.REACT_APP_API_URL_VR_EDITOR}/scenario-builder/container-web`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(
                {
                    "name": name || `Nowy kontener ${Date.now()}`,
                    "GUID": guid,
                    "limit": limit || 6
                }
            ),
        });
        if (!res.ok) throw new Error("Błąd dodawania scenariusza");
        const data = await res.json();
        return data;
    } catch (err) {
        console.error(err);
    }
};



export const deleteContainer = async (id) => {
    try {
        const res = await fetch(`${process.env.REACT_APP_API_URL_VR_EDITOR}/scenario-builder/container/${id}`, {
            method: "DELETE",
        });
        if (!res.ok) throw new Error("Błąd usuwania kontenera");
        const data = await res.json();
        return data;
    } catch (err) {
        console.error(err);
    }
};